import { Component, ElementRef, OnInit, Renderer2, ViewChild } from '@angular/core';
import { Button } from '../../../../../shared/model/enum';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { SendDataService } from '../../../../../shared/services/send-data.service';

@Component({
  selector: 'app-serial-numbers',
  templateUrl: './serial-numbers.component.html',
  styleUrls: ['./serial-numbers.component.scss']
})
export class SerialNumbersComponent implements OnInit {
  @ViewChild('textArea') textArea: ElementRef<HTMLTextAreaElement>;
  title
  data:any ={}
  enumButtonName = Button;
  lines: string[] = [];
  totalCount: number = 0;
  constructor(public activeModal: NgbActiveModal,public toaster: ToastrService,
      public renderer: Renderer2,
       public sendDataService: SendDataService,
        ) {
          this.data.title = this.data?.title ?? 'Save';
          this.data.value = this.data?.value ?? '';
        }
 
  ngOnInit(): void {
    if(this.data?.serialNumber?.length > 0){
      this.data.totalCount = this.totalCount = this.data?.serialNumber[0]?.serialNumber?.length ?? 0 ;
      this.data.dataArray = this.data?.serialNumber[0]?.serialNumber;
      this.data.value = this.data.dataArray.map(x => x.value).join('\n');
     //  this.data.value = this.data.dataArray.join('\n');
    }
  }
 
  ngAfterViewInit() {
    this.textArea?.nativeElement?.focus();
  }

  updateCount(value) {
    this.data.value = value
    this.data.totalCount = this.totalCount = this.data?.value
    .trim()                     
    .split('\n')                
    .filter(line => line.trim() !== '') 
    .length;
    if(this.data?.disable)return
    const existingIndex = this.data?.dataArray?.findIndex(x => x.count === this.totalCount);
this.data.dataArray = this.data?.dataArray ?? [];
if(existingIndex == undefined){
  this.data.dataArray.push({ value: this.data.value, count: this.totalCount });
  return
}
if (existingIndex === -1) {
  this.data.dataArray.push({ value: this.data.value, count: this.totalCount });
} else {
  this.data.dataArray[existingIndex] = { value: this.data.value, count: this.totalCount };
}
  }

  onEditClick() {
    if(this.data?.disable)return
    if(this.data?.dataArray?.length > 0){
    const lines = this.data?.value?.split('\n');
    const filteredLines = lines.filter(line => line !== '');
    if(this.data.totalCount !== filteredLines?.length)return
    this.data.dataArray = filteredLines.map(line => ({
      value: line,
      count: line.length
    }));
  }
    this.toaster.success(this.data?.title === 'Edit' ? 'Updated Serial Numbers Successfully.' : 'Added Serial Numbers Successfully.');
    this.activeModal.close({ res: this.data, confirm: true })
  }
}
